<template>
  <main>
  </main>
</template>

<script>
import {get, set, isEmpty} from 'lodash'
import CommonMixin from '@/mixins/CommonMixin'
import DirectStoreAccessMixin from '@/mixins/DirectStoreAccessMixin'
import DisplayErrorMixin from '@/mixins/DisplayErrorMixin'
export default {
  name: 'FKMODconnectAuth',
  mixins: [ CommonMixin, DirectStoreAccessMixin, DisplayErrorMixin ],
  methods: {
    checkFirstTime: async function () {
      try {
        // APIを叩いて同意済みかどうかを確認する
        const res = await this.callApi('DcmUserInfoGet', {})
        if (get(res, 'data.result', true)) {
          this.$store.commit('setUserPolicyAgreed', get(res, 'data.value.user_policy_flag', 'false'))
        } else {
          this.errorFromApi(res.data.errorCode, res.data.error)
          this.$store.commit('setUserPolicyAgreed', false)
        }
      } catch (error) {
        this.errorFromAxios(error)
        this.$store.commit('setUserPolicyAgreed', false)
      } finally {
        if (this.$store.getters.userPolicyAgreed) {
          if (!isEmpty(sessionStorage.getItem('directStoreCode'))) {
            // 店舗ダイレクトジャンプ
            this.$router.push({ name: 'ReceiveMethod' })
          } else {
            // 店舗コード指定なし
            this.$router.push({ name: 'Index' })
          }
        } else {
          this.$router.push({ name: 'UserPolicy' })
        }
      }
    }
  },
  // onload
  beforeMount () {
    // dアカウントコネクトステータス確認
    const errcode = get(this, '$route.query.errcode', null)
    if (errcode === '0') {
      const userInfo = {}
      set(userInfo, 'last_store', [])
      set(userInfo, 'server_time', null)
      sessionStorage.setItem('login', JSON.stringify(userInfo))
      this.$store.dispatch('setAuthCompletedFromApp', true)
      this.$store.dispatch('enableDPay')
      this.$store.dispatch('setUserAuthority', get(userInfo, 'authority', 1))
      this.checkFirstTime()
    } else {
      sessionStorage.removeItem('login')
      this.moveToError('ERR_701')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DconnectAuth.vue